import {
  SELF_MIGRATE_TO_USAGE_BILLING,
  USAGE_BILLING_ENABLED,
} from 'components/admin/utils/feature-flags';
import { useBanners } from 'components/GlobalBanners/globalBanners';
import { useFeatureFlags } from 'controllers/contexts/featureFlags';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { BANNER_TYPES, logLinkClickEvent, PRODUCT_AREAS } from 'utils/events';

const BANNER_ID = 'USAGE_BILLING_ANNOUNCEMENT';

export const useUsageBillingAnnouncement = () => {
  const { addBanner, removeBanner } = useBanners();
  const { hasInitialized, hasLabsFlag } = usePSLabs();
  const { hasFlag }: any = useFeatureFlags();
  const history = useHistory();
  const selfMigrateFlag = hasLabsFlag(SELF_MIGRATE_TO_USAGE_BILLING);
  const usageBillingEnabled = hasFlag(USAGE_BILLING_ENABLED);

  useEffect(() => {
    if (usageBillingEnabled || !hasInitialized || !selfMigrateFlag) {
      return;
    }

    addBanner({
      id: BANNER_ID,
      data: {
        variant: 'guidance',
        heading: 'Simplify your spend',
        bodyText:
          'Switch to usage billing today and say goodbye to pre-purchasing credits!',
        primaryAction: {
          onClick: (event) => {
            logLinkClickEvent(event, { product_area: PRODUCT_AREAS.GLOBAL });
            history.push('/billing/switch-to-usage');
          },
          text: 'View Usage Billing Plans',
        },
      },
      eventTrackingOptions: {
        bannerType: BANNER_TYPES.BILLING_USAGE_CREDIT,
      },
    });
    return () => {
      removeBanner(BANNER_ID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasInitialized, selfMigrateFlag, usageBillingEnabled]);
};
